module.exports = __webpack_public_path__ + "c3cf75a4d5ca45ec757bbd55ae226eaa.woff2";


//////////////////
// WEBPACK FOOTER
// ../shared/css/rover_icons/fonts/rover-icons.woff2?f8o35m
// module id = 2289
// module chunks = 65